export default __webpack_public_path__ + "static/media/mis.9f01db95.jfif";